export type MonthlyEnergySource = `empty` | `estimated` | `user`

export const resolveMonthlyEnergySource = (
  costValue: number | null | undefined,
  usageValue: number | null | undefined,
  manualFlag: boolean | null | undefined,
): MonthlyEnergySource => {
  if (manualFlag) {
    return `user`
  }

  if ((costValue ?? 0) > 0 || (usageValue ?? 0) > 0) {
    return `estimated`
  }

  return `empty`
}
